import React from 'react';
import clsx from 'clsx';

interface Props {
  children: React.ReactNode;
  className?: string;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  onClick?: () => void;
}

export default function ListItem({
  children,
  className,
  startAdornment,
  endAdornment,
  onClick,
}: Props) {
  const isInteractive = !!onClick;

  return (
    <li
      className={clsx(
        'base-list__item',
        { 'base-list__item--interactive': isInteractive },
        className,
      )}
      onClick={onClick}
    >
      {startAdornment && (
        <div className="base-list__item-start">{startAdornment}</div>
      )}

      <div className="base-list__item-content">{children}</div>

      {endAdornment && (
        <div className="base-list__item-end">{endAdornment}</div>
      )}
    </li>
  );
}
